import { createKeyedSignal } from "@react-rxjs/utils"
import { curveBasis } from "d3"
import { equals } from "lodash/fp"
import { combineLatest, distinctUntilChanged, map, startWith } from "rxjs"

import { getHistoricalPrices$, HistoryPrice } from "@/services/prices"
import { getDataPoints, toSvgPath, withScales } from "@/utils/historicalChart"

import { symbolBind } from "../TileContext"

const VIEW_BOX_WIDTH = 200
const VIEW_BOX_HEIGHT = 90

const [size$, setSize] = createKeyedSignal<
  string,
  { width: number; height: number }
>()

const [useHistoricalPath, historicalGraph$] = symbolBind((symbol: string) =>
  combineLatest([
    getHistoricalPrices$(symbol),
    size$(symbol).pipe(
      startWith({
        width: VIEW_BOX_WIDTH,
        height: VIEW_BOX_HEIGHT,
      }),
      distinctUntilChanged(equals),
    ),
  ]).pipe(
    map(([historicalPrices, { width, height }]) => {
      const dataPoints = getDataPoints<HistoryPrice>((price, idx) => [
        new Date(idx),
        price.mid,
      ])(historicalPrices)

      const scales = withScales([0, width], [0, height])(dataPoints)
      return toSvgPath(curveBasis)(scales)
    }),
  ),
)
export { historicalGraph$, setSize, useHistoricalPath }
